import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const benefits = [
  {
    title: "100% Local Privacy",
    desc: "Your images never touch a server. All forensic analysis happens entirely within your browser's runtime environment.",
    icon: FiIcons.FiLock,
    color: "text-blue-500",
    bg: "bg-blue-50"
  },
  {
    title: "Forensic Heuristics",
    desc: "Advanced algorithms detect inconsistencies between file system timestamps and embedded EXIF data patterns.",
    icon: FiIcons.FiSearch,
    color: "text-purple-500",
    bg: "bg-purple-50"
  },
  {
    title: "Software Attribution",
    desc: "Identify editing history by detecting signatures from Photoshop, Lightroom, Canva, and mobile editing apps.",
    icon: FiIcons.FiCpu,
    color: "text-orange-500",
    bg: "bg-orange-50"
  },
  {
    title: "Court-Ready Reports",
    desc: "Generate comprehensive PDF investigation reports with timestamp timelines and risk factor breakdowns.",
    icon: FiIcons.FiFileText,
    color: "text-green-500",
    bg: "bg-green-50"
  }
];

const Benefits = () => {
  return (
    <section className="py-12 border-t border-gray-100">
      <h3 className="text-2xl font-bold text-center mb-10">Why Investigators Trust Us</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {benefits.map((b, i) => (
          <div key={i} className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition">
            <div className={`${b.bg} ${b.color} w-12 h-12 rounded-xl flex items-center justify-center mb-4`}>
              <SafeIcon icon={b.icon} className="text-2xl" />
            </div>
            <h4 className="font-bold text-gray-900 mb-2">{b.title}</h4>
            <p className="text-sm text-gray-500 leading-relaxed">{b.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Benefits;